// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__Cqii0","text":"NotFoundPage_text__OhoXe","image":"NotFoundPage_image__Z8j7z"};